import React, {useEffect, useState} from "react";
import "../sass/CookieBanner.scss"

export default function CookieBanner() {
    const [showPopup, setShowPopup] = useState(false)

    useEffect(() => {
        const cookieAccepted = document.cookie.split(';').some((item) => item.trim().startsWith('cookie_block=1'));

        if (!cookieAccepted) {
            setShowPopup(true);
        }
    }, []);

    const clickAccept = () => {
        document.cookie = `cookie_block=1; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
        setShowPopup(false);
    }

    if (showPopup) {
        return (
            <div className="cookie-block" id="clckblck">
                <div className="cookie-block__text-wrapper">
                    <div className="cookie-block__text">Мы обрабатываем
                        <a target="_blank"
                           className="cookie-block__link"
                           href="https://citylink.pro/media/text/pdn-citylink/"> cookies-файлы</a>,
                        <br/>чтобы сделать наш сайт удобнее для вас
                    </div>
                </div>
                <div className="cookie-block__button-wrapper">
                    <button className="cookie-block__button" onClick={clickAccept}>Хорошо</button>
                </div>
            </div>
        )
    } else {
        return null;
    }
}